var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('router-link',{staticClass:"no-underline",attrs:{"to":_vm.countryHomePath}},[_c('Logo',{class:_vm.imageClass,style:({ color: _vm.color })})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }